import { useCallback, useEffect, useState } from 'react';
import { listWps } from '../api/dev';
import type { WorkPackage } from '../types/dev';
import type { ErrorLogEntry } from '../api/errorLog';

export function buildErrorKey(row: ErrorLogEntry): string {
  return [row.source, row.error_code, row.path].filter(Boolean).join(' · ');
}

export function useWpMap(errors: ErrorLogEntry[]) {
  const [map, setMap] = useState<Map<string, WorkPackage>>(new Map());
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!errors.length) return;
    setLoading(true);
    try {
      const wps = await listWps();
      const next = new Map<string, WorkPackage>();
      for (const e of errors) {
        const key = buildErrorKey(e);
        const match = wps.find((w) => w.title === key);
        if (match) next.set(key, match);
      }
      setMap(next);
    } finally {
      setLoading(false);
    }
  }, [errors]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { void refresh(); }, [refresh]);

  return { map, loading, refresh };
}
